import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { Record } from "appworks/model/gameplay/records/record";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { FooterComponent } from "slotworks/components/footer/footer-component";
import { FreespinWinResult } from "slotworks/model/gameplay/records/results/freespin-win-result";
import { SymbolWinResult } from "slotworks/model/gameplay/records/results/symbol-win-result";
import { WaysResult } from "slotworks/model/gameplay/records/results/ways-result";
import { FreespinCelebrationState } from "slotworks/state-machine/standard/states/freespin-celebration-state";

export class AgsFreespinCelebrationState extends FreespinCelebrationState {

    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord();
        const freespins = record.getResultsOfType(FreespinWinResult);

        if (freespins.length === 0) {
            this.complete();
        } else {
            const isRetrigger = gameState.getCurrentGame().inFreespins();
            if (!isRetrigger) { gameWrapper.enableFeatureMode(); }
            
            Services.get(SoundService).customEvent("bonus_bell");
            return super.onEnter();
        }
    }
    protected showFooterMessage(
        freespinsWon: number,
        linked: SymbolWinResult,
        record: Record
    ): void {
        if (freespinsWon > 0) {
            Components.get(FooterComponent).showWaysWin(linked as WaysResult, linked.symbolType);
        }
    }
}
